// SEO helper za paginirane listing stranice.
//
// Best-practice za paginaciju je da samo strana 1 bude indeksirana, a strane
// 2+ idu kao `noindex, follow`. Razlog: strane 2+ imaju vrlo sličan sadržaj
// kao strana 1 (samo drugačiji items u listi), pa Google to vidi kao
// near-duplicate content i može da smanji ranking cele sekcije. Ali link-ovi
// sa tih strana ka pojedinačnim oglasima/proizvodima TREBA da se kraulaju —
// otuda `follow`.
//
// Prazna lista (nema nijednog oglasa) takodje ide `noindex, follow`: nema sta da se indeksira.
//
// Korišćenje:
//   const page = computed(() => Number(route.params.page))
//   usePaginationRobots(page)
//   usePaginationRobots(page, empty)   // empty: ref/getter boolean

import type { MaybeRefOrGetter } from 'vue'

export function usePaginationRobots(page: MaybeRefOrGetter<number>, empty: MaybeRefOrGetter<boolean> = false) {
  useHead(() => {
    const p = Number(toValue(page)) || 1
    return {
      meta: [{
        name: 'robots',
        content: p > 1 || toValue(empty)
          ? 'noindex, follow'
          : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
      }]
    }
  })
}
